import React, { useState, useEffect, useRef, useCallback } from 'react';
import style from './DiseaseSetting.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import ToastPopup from '../../../../components/comm/ToastPopup';
import Modal from '../../../../components/comm/Modal';
import TabList from '@mui/lab/TabList';

import { useNavigate, useLocation } from 'react-router-dom';
import URL from '../../../../constants/url';

import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';

const PAGE_SIZE = 40;

const SAMPLE_LIST = [
    { id: 12, data: '1형 당뇨'},
    { id: 6, data: '고혈압'},
    { id: 13, data: '고지혈증'},
  ];


const DiseaseSetting = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const [pageNo, setPageNo] = useState(1);
    const [hasNext, setHasNext] = useState(true);
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const scrollRef = useRef(null);

    //탭 
    const [value, setValue] = React.useState('1');
    
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    //전송중 체크
    const isSendingRef = useRef(false);

    //로딩
    const [isLoading, setIsLoading] = useState(false);    
    const [keyword, setKeyword] = useState('');

    //검색 페이지
    const [onFocusMenuBox, setOnFocusMenuBox] = useState(1);
    const [searchedList, setSearchedList] = useState([]);
    const [searchedPageNo, setSearchedPageNo] = useState(1);
    const [searchedHasNext, setSearchedHasNext] = useState(true);

    const [diseaseList, setDiseaseList] = useState([]); // 건강바이블 리스트
    const [checkedList, setCheckedList] = useState(() =>
        Array.isArray(location.state?.checkedList) ? location.state.checkedList : []
    );   //체크된 목록 리스트 
    const [checkedCount, setCheckedCount] = useState(0);  // 목록 갯수
    const [selectComplete, setSelectComplete] = useState(true);  // [선택완료] 버튼 활성화 

    const [modalOpen, setModalOpen] = useState(false);  //모달창
    const [dgnssList, setDgnssList] = useState([]); //주요 진단
    const [allDiseaseList, setAllDiseaseList] = useState([]);      // 전체 질환
    const [matchedDiseases, setMatchedDiseases] = useState([]);    // 추천 질환

    const closeModal = () => {
        setModalOpen(false);
    }
    
    //데이터 불러오기
    const getDiseaseInfo = async (tabKey, pageNo) => {
    
        if (isSendingRef.current) return;
        isSendingRef.current = true;
        setIsLoading(true);
        
        const url = "/homecare/disease/retrieveDiseaseList";
        const reqBody = {
            choseong : tabKey === "1" ? '' : tabKey,
            pageNo : pageNo,
            pageSize : PAGE_SIZE
        }
        try {
            const res = await axiosApi.post(url, reqBody);
            
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const newList = res.data.result.diseaseList;
                setDiseaseList(prev => (pageNo === 1 ? newList : [...prev, ...newList]));
                setHasNext(res.data.result.hasNext);
                
            } else {
                setDiseaseList([]);
                setHasNext(false);
            }
        } catch (err) {
            console.log(err);
        } finally {
            isSendingRef.current = false;
            setIsLoading(false);
        }

    };


    const retrieveSummaryInfo = useCallback(async () => {

        const url = "/mypage/retrieveSummaryInfo";

        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                Authorization: jToken,
            },
        }
        await axiosApi.post(url, {}, reqOptions)
        // await axiosApi.post(url, {})
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setDgnssList([...res.data.result.dgnssList]);
            } 
        })
        .catch(err => {
            console.error("요약정보 호출 중 오류  : ", err);
        })

    }, []);

    useEffect(() => {
        retrieveSummaryInfo();
    }, [retrieveSummaryInfo]);

    

    //검색 데이터 불러오기
    const searchDiseaseInfo = async (tabKey, pageNo) => {
    
        if (isSendingRef.current) return;
        isSendingRef.current = true;
        setIsLoading(true);
        
        const url = "/homecare/disease/retrieveDiseaseList";
        const reqBody = {
            choseong : '',
            pageNo : pageNo,
            pageSize : PAGE_SIZE,
            keyword : keyword
        }
        try {
            const res = await axiosApi.post(url, reqBody);
            
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const searchedList = res.data.result.diseaseList;
                setSearchedList(prev => (pageNo === 1 ? searchedList : [...prev, ...searchedList]));
                setSearchedHasNext(res.data.result.hasNext);
            } else {
                setSearchedList([]);
                setSearchedHasNext(false);
            }
        } catch (err) {
            console.log(err);
        } finally {
            isSendingRef.current = false;
            setIsLoading(false);
        }
    };

    // 탭 변경 시 데이터 초기화 + 첫 페이지 조회
    useEffect(() => {
        setDiseaseList([]);
        setPageNo(1);
        setHasNext(true);
        getDiseaseInfo(value, 1);
    }, [value]);

    // IntersectionObserver (스크롤 끝 감지)
    useEffect(() => {
        if (!scrollRef.current) {
            return;
        }
        const observer = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasNext && !isLoading && !isSendingRef.current && onFocusMenuBox === 1) {
                // 다음 페이지 데이터 바로 호출
                getDiseaseInfo(value, pageNo + 1);
                setPageNo(prev => prev + 1);
            }

            if (entries[0].isIntersecting && searchedHasNext && !isLoading && !isSendingRef.current && onFocusMenuBox === 2) {
                // 다음 페이지 데이터 바로 호출
                searchDiseaseInfo(value, searchedPageNo + 1);
                setSearchedPageNo(prev => prev + 1);
            }
        }, { threshold: 1.0 });

        const current = scrollRef.current;
        observer.observe(current);

        return () => {
            observer.unobserve(current);
            observer.disconnect();
        };
    }, [value, hasNext, isLoading, searchedHasNext]);

    // pageNo 증가 시 다음 페이지 호출
    useEffect(() => {
        if (pageNo > 1) getDiseaseInfo(value, pageNo);
    }, [pageNo]);

    // searchedPageNo 증가 시 다음 페이지 호출
    useEffect(() => {
        if (searchedPageNo > 1) searchDiseaseInfo(value, searchedPageNo);
    }, [searchedPageNo]);


    // 체크된 목록 저장
    const saveCheckedList = async () => {
    
        if (isSendingRef.current) return;
        isSendingRef.current = true;
        setIsLoading(true);
        const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));

        const url = "/homecare/disease/saveUsrCstmzDissInfoList";
        const reqBody = {
            usrInfoId : loginUser.usrInfoId,
            dissList : checkedList
        }
        try {
            const res = await axiosApi.post(url, reqBody);
            
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                navigate(`${URL.HOME_CARE_MAIN}?tab=3`, {state : {showToast : true, toastMessage : '설정 완료!'}});
            } else {
                console.log("저장 중 오류");
            }
        } catch (err) {
            console.log(err);
        } finally {
            isSendingRef.current = false;
            setIsLoading(false);
        }
    };

    const checkedHandler = (checked, item) => {
        if (checked) {
            if (checkedList.length >= 3) {
                setModalOpen(true);
                return;
            }
            setCheckedList(prev => [...prev, {hblNo : item.hblNo, dissNm : item.hblNm}]);
        } else {
            setCheckedList(prev => prev.filter(el => el.hblNo !== item.hblNo));
        }
    };
    
    // checkedList 변경 시 처리
    useEffect(() => {
        setCheckedCount(checkedList.length);
        setSelectComplete(checkedList.length === 0);
    }, [checkedList]);



    //삭제 버튼
    const onRemove = item => {
        setCheckedList((prev) => prev.filter((el) => el.hblNo !== item.hblNo));
        setCheckedCount(checkedList.length  - 1);
        setSelectComplete(true)
      };




    const handleChangeOn = (event) => {
        //const safeValue = event.target.value.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9\s]/g, ''); //input값 validation
        const safeValue = event.target.value.replace(/[^\uAC00-\uD7A3\u1100-\u11FF\u3130-\u318F a-zA-Z0-9]/g, '');
        setKeyword(safeValue);
    }  

    const handleSearch = () => {
        if (keyword === '') {
            setToastMessage('검색어를 입력해주세요.');
            setToast(true);
            return;
        }
        else {
            searchDiseaseInfo(value, 1);
        }
    }  

    // 모든 diseaseList 불러오기
    const getAllDiseaseList = useCallback(async () => {
        let pageNo = 1;
        let allDiseases = [];
        let hasNext = true;

        while (hasNext) {
            const res = await axiosApi.post("/homecare/disease/retrieveDiseaseList", {
                choseong: '',
                pageNo: pageNo,
                pageSize: PAGE_SIZE
            });

            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                allDiseases = [...allDiseases, ...res.data.result.diseaseList];
                hasNext = res.data.result.hasNext;
                pageNo += 1;
            } else {
                hasNext = false;
            }
        }

        setAllDiseaseList(allDiseases);

        // dgnssList와 비교
        const dgnssNames = [...new Set(dgnssList.map(d => {
            const dgnssKorNm = d.dgnssKorNm;
            const dgnssEngNm = d.dgnssEngNm;
            if(!dgnssKorNm) return dgnssEngNm.trim();
            return dgnssKorNm.trim();
        }))];
        const matched = allDiseases.filter(disease =>
            dgnssNames.includes(disease.hblNm.trim())
        );
        setMatchedDiseases(matched);

    }, [dgnssList]);

    // dgnssList 불러온 뒤 전체 질환도 불러오기
    useEffect(() => {
        if (dgnssList.length > 0) {
            getAllDiseaseList();
        }
    }, [dgnssList, getAllDiseaseList]);




    return (
        <>
            <HeadSub title="질환 설정" />
 
            <div id="sub-content" data-layout="white">

                <div className={style['search-wrap']} data-active={onFocusMenuBox !== 1 ? "on" : null}>
                    <div className={style['search-group']}>
                        <div className={style['search-box']}>
                            <input 
                                type="text" 
                                placeholder='질환명을 입력해주세요'
                                value={keyword}
                                onFocus={() => setOnFocusMenuBox(2)}
                                onChange={(event) => handleChangeOn(event)}
                            />
                            <button className={style['search-btn']} onClick={handleSearch}></button>
                            
                        </div>
                        {onFocusMenuBox !== 1 ? 
                            (<button 
                                className={style['cancel-btn']} 
                                onClick={()=> {
                                    setOnFocusMenuBox(1)
                                    setKeyword('');
                                    }
                                }> 
                                <span>취소</span> 
                            </button>) : null 
                        }
                    </div>
                    
                    <div className={style['selecting-box']}>

                        {checkedList.length === 0 && (
                            <>
                            </>
                        )}

                        {checkedList.length !== 0 && (

                            <div className={style['scroll-box']}>
                                
                                {checkedList.map(item => {
                                return (
            
                                    <div key={item.hblNo} className={style['selecting-btn']}>
                                        <p>{item.dissNm}</p>
                                        <button className={style['close-btn']} onClick={() => onRemove(item)}></button>
                                    </div>
                                    );
                                })} 
                            </div>
                        )}    
                    
                    </div>
                </div>

                <div className="inner-wrap" data-side-padding="0">

                    {/* 추천 질환 (주요진단 목록이 있을시 노출, 내정보 > 요약정보 > 주요진단) :: S */}

                    {matchedDiseases.length > 0 && (
                        <div className={style['recommend-lists']}>
                            <p>추천 질환</p>
                            <ul>
                                {matchedDiseases.map(item => (
                                    <li key={item.hblNo}>
                                        <span>{item.hblNm}</span>
                                        <div className='chkbox-custom' data-chkbox="over-chk-btn">
                                            <input 
                                                type="checkbox" 
                                                id={`chk-${item.hblNo}`} 
                                                value={item.hblNm} 
                                                checked={checkedList.some(el => el.hblNo === item.hblNo)} 
                                                onChange={(e) => checkedHandler(e.target.checked, item)}
                                            />
                                            <label htmlFor={`chk-${item.hblNo}`}>선택</label>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}



                    {/* 전체 질환 :: S */}
                    <div className={style['all-disease']}>


                        
                        <TabContext value={value} className={style["tab-context"]}>

                            <div className={style['bot-title-box']} data-top-position={(checkedCount !== 0) ? "add" : ""}> 
                                <p>전체 질환</p>
                                <TabList
                                    onChange={handleChange}
                                    aria-label="lab API tabs example"
                                    variant="scrollable"
                                    scrollButtons={false}
                                    className={style["tab-lists"]}
                                >
                                    <Tab label="전체" value="1" disableRipple />
                                    <Tab label="ㄱ" value="ㄱ" disableRipple />
                                    <Tab label="ㄴ" value="ㄴ" disableRipple />
                                    <Tab label="ㄷ" value="ㄷ" disableRipple />
                                    <Tab label="ㄹ" value="ㄹ" disableRipple />
                                    <Tab label="ㅁ" value="ㅁ" disableRipple />
                                    <Tab label="ㅂ" value="ㅂ" disableRipple />
                                    <Tab label="ㅅ" value="ㅅ" disableRipple />
                                    <Tab label="ㅇ" value="ㅇ" disableRipple />
                                    <Tab label="ㅈ" value="ㅈ" disableRipple />
                                    <Tab label="ㅊ" value="ㅊ" disableRipple />
                                    <Tab label="ㅋ" value="ㅋ" disableRipple />
                                    <Tab label="ㅌ" value="ㅌ" disableRipple />
                                    <Tab label="ㅍ" value="ㅍ" disableRipple />
                                    <Tab label="ㅎ" value="ㅎ" disableRipple /> 
                                </TabList>
                            </div>
                            {/* <TabPanel value="1">
                                전체
                            </TabPanel> */}    
                        </TabContext>


                        <div className={style['tap-content-box']}>
                            <div className={style['list-box']}>
                                <ul>
                                
                                {diseaseList.map(item => {
                                    return (
                                        <li key={item.hblNo}>
                                            <span>{item.hblNm} {/*({item.mngDeptNm})*/}</span>
                                        
                                            <div className='chkbox-custom' data-chkbox="over-chk-btn">
                                                <input type="checkbox" id={`chk-${item.hblNo}`} value={item.hblNm} checked={checkedList.some(el => el.hblNo === item.hblNo)} onChange={(e) => checkedHandler(e.target.checked, item)}/>
                                                <label htmlFor={`chk-${item.hblNo}`}>선택</label>
                                            </div>
                                        </li>
                                        
                                        );
                                 })}
                                    
                                </ul>
                                <div ref={scrollRef} style={{ height: 1 }}></div>
                            </div>
                            
                        </div>


                    </div>
                    {/* 전체 질환 :: E */}


                    {/* 하단 다음 버튼 영역 :: S */}
                    <div className="bottom-fixed-box" data-type="b" data-z-index="100">
                            <div className="inner-box">

                                 {/* 버튼이 1개일때 */}
                                <div className='btn-layout' data-btn-num="1"> 
                                    <button className="btn" onClick={() => saveCheckedList()} data-btn-type="fill-main" 
                                        disabled={selectComplete} 
                                        data-btn-size="lg" data-btn-width="auto" data-btn-radius="md">
                                        <span>선택 완료 ({checkedCount}/3)</span>
                                    </button>
                                </div>
 
                            </div>
                    </div>               
                    {/* 하단 다음 버튼 영역 :: E */} 




                     {/* 전체메뉴::S */}
                    {onFocusMenuBox === 2 && (                   
                    <div className={`${style['search-auto-box']} ${checkedList.length !== 0 ? style['has-selected'] : ''}`}>
                        <div className={style['inner-box']}>
                            <ul>

                            {searchedList.map(item => {
                                return (
                                    <li key={item.hblNo}>
                                        <span>{item.hblNm} {/*({item.mngDeptNm})*/}</span>
                                    
                                        <div className='chkbox-custom' data-chkbox="over-chk-btn">
                                            <input type="checkbox" id={`chk-${item.hblNo}`} value={item.hblNm} checked={checkedList.some(el => el.hblNo === item.hblNo)} onChange={(e) => checkedHandler(e.target.checked, item)}/>
                                            <label htmlFor={`chk-${item.hblNo}`}>선택</label>
                                        </div>
                                    </li>
                                    
                                    );
                                })} 
                                
                                
                            </ul>
                            <div ref={scrollRef} style={{ height: 1 }}></div>
                        </div>
                            
                    </div>
                    )}
                </div>
            </div>
            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                    position="center"
                    opacity="90"
                />
            )} 

            <Modal isOpen={modalOpen} setIsOpen={setModalOpen} >
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p>질환은 최대 3개까지 설정할 수 있습니다.</p>
                        </div>
                    </div>

                    <div className="modal-bottom-box"> 
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-main"  data-btn-size="md" onClick={closeModal}>
                                <span>확인</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default DiseaseSetting;
